import { render } from "./Filter.vue?vue&type=template&id=0320e2c4&scoped=true"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"

import "./Filter.vue?vue&type=style&index=0&id=0320e2c4&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0320e2c4"]])

export default __exports__